<template>
  <div class="clearfix">
    <ul class="status_progress">
      <li v-for="(item,index) in stateCodeList" :key="index" :class="{ status_color_select: isStateCodeSelected(item.stateCode) }">
        {{ item.stateEName }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    stateCode: "",
    stateCodeSource: {
      default: []
    }
  },
  data () {
    return {
      userCodeList: ['TTMTTAREX', 'TTMTTAHKG', "AKMHKG", "AKMREX"],
      specialStateList: ["SE10", "SE09"],
    };
  },
  methods: {

    //是否选择了状态Code
    isStateCodeSelected (code) {
      // console.log(this.stateCode)
      if (this.stateCode === null) {
        return;
      }
      return (
        this.stateCode
          .split(",")
          .filter(
            (c) => c == code || (code == "SA12" && (c == "SA12" || c == "SE16"))
          ).length > 0
      );
    },
  },
  computed: {
    stateCodeList () {
      var user = this.$store.getters.user;
      // console.log(user.userCode)
      // console.log(this.userCodeList)
      if (user == null || this.userCodeList.indexOf(user.userCode) == -1) {
        return this.stateCodeSource;
      }

      return this.stateCodeSource.filter(
        (r) => this.specialStateList.indexOf(r.stateCode) == -1
      );
    },
  },
};
</script>